<template>
  <div
    ref="modal"
    tabindex="0"
    @keyup.esc="onPressEsc">
    <div
      v-if="!hide"
      class="modal-container">
      <div class="close-modal">
        <i
          class="icon-x"
          @click="close()"/>
      </div>
      <div class="modal-content">
        <slot/>
      </div>
    </div>
    <div
      v-if="!hide"
      class="overlay"
      @click="onClickFade"/>
  </div>
</template>

<script>
export default {
  name: 'AuthBox',
  props: {
    closeKeyEsc: {
      type: Boolean,
      default: true
    },
    closeClickFade: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      hide: true
    }
  },
  watch: {
    hide (val) {
      if (!val) {
        setTimeout(() => {
          this.$refs.modal.focus()
        }, 100)
      }
    }
  },
  methods: {
    open () {
      this.hide = false
      document.body.style.overflow = 'hidden'
    },
    close () {
      this.hide = true
      this.$emit('close')
      // this.$router.go(-1)
      document.body.style.overflow = 'auto'
    },
    onPressEsc () {
      if (this.closeKeyEsc) {
        this.close()
      }
    },
    onClickFade () {
      if (this.closeClickFade) {
        this.close()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .overlay {
    background-color: rgba(black, .6);
    width: 100vw;
    height: 100vh;
    top: 0;
    position: fixed;
    z-index: 202;
    display: flex;
    align-items: center;
    overflow: hidden !important;
  }

  .modal-container {
    z-index: 203;
    background-color: white;
    width: 375px;
    position: fixed;
    top: 15%;
    right: 0;
    left: 0;
    margin: 0 auto;
    padding: 30px;
    @media #{$Laptop} {
      top: 4%;
    }
    @media #{$NoteS} {
      top: 0;
      width: 100%;
      height: 100%;
    }

    .close-modal {
      text-align: right;
      i{
        cursor: pointer;
        font-size: 18px;
      }
    }
    .modal-content {
      padding: 0 30px 0 30px;
      @media #{$NoteS} {
        padding: 73px 0 0 0;
        margin: 0 auto;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/auth/auth-box.vue